import { useNavigate } from "react-router-dom";

export function useRoutablePages() {
  const navigate = useNavigate();

  return {
    toVehiclesByMake(code: string) {
      navigate(`/vehicleFiles/${code}`);
    },

    getVehicleFileDetails(vehicleFileNumber: string) {
      return `/vehicleFiles/details/${vehicleFileNumber}`;
    },

    toVehicleFileDetails(vehicleFileNumber: string) {
      navigate(this.getVehicleFileDetails(vehicleFileNumber));
    },

    getVehicleFileHistory(vehicleFileNumber: string) {
      return `/vehicleFiles/history/${vehicleFileNumber}`;
    },

    toReleaseHistory(name: string) {
      navigate("/releases/history/" + name);
    },

    toDrawingTemplateEdit(name: string) {
      navigate(`/drawings/templates/edit/${name}`);
    },

    getModelInfoEditForYearlyReview(vehicleFileNumber: string) {
      return `/vehicleFiles/details/${vehicleFileNumber}?tab=modelInfo`;
    },

    toModelInfoEditForYearlyReview(
      vehicleFileNumber: string,
      makeCode: string | undefined,
      currentYear: number,
      newYearEnd: number,
      reviewed: boolean,
    ) {
      navigate(this.getModelInfoEditForYearlyReview(vehicleFileNumber), {
        state: {
          makeCode: makeCode,
          currentYear: currentYear,
          newYearEnd: newYearEnd,
          reviewed: reviewed,
        },
      });
    },

    getModelInfoToReview(makeCode: string | undefined) {
      return `/yearlyOverview/reviewableDetails/${makeCode}`;
    },

    toModelInfoToReview(makeCode: string | undefined, yearEnd: number) {
      navigate(this.getModelInfoToReview(makeCode), {
        state: { makeCode: makeCode, yearEnd: yearEnd },
      });
    },

    getYearlyReviewList() {
      return `/yearlyOverview`;
    },

    toYearlyReviewList(makeCode: string | undefined, yearEnd: number) {
      navigate(this.getYearlyReviewList(), {
        state: { makeCode: makeCode, yearEnd: yearEnd },
      });
    },
  };
}
